import { store } from '@/store/store'
import axios from 'axios'
import config from '../config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}api/upload-file`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const uploadFileApi = {
  getSignS3Video: (request) => {
    // file-name
    // file-type
    const {
      config = {
        params: {}
      }
    } = request

    // url = url.replace(/#/gim, '')

    return instance().get(`/sign-s3-video`, config)
  },
  postUpload: (request) => {
    return new Promise((resolve, reject) => {
      const { data } = request
      let signedRequest = data.signedRequest
      const formData = new FormData()
      formData.append('acl', 'public-read')
      Object.keys(signedRequest.fields).forEach((key) => {
        formData.append(key, signedRequest.fields[key])
      })

      // Actual file has to be appended last.
      formData.append('file', data.file)

      const xhr = new XMLHttpRequest()
      xhr.upload.addEventListener(
        'progress',
        (event) => {
          var percent = (event.loaded / event.total) * 100
          store.state.progress = percent
        },
        false
      )
      xhr.open('POST', signedRequest.url, true)
      xhr.send(formData)
      xhr.onload = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200 || xhr.status === 204) {
            resolve(xhr)
          } else {
            alert('Could not upload file.')
            reject('Could not upload file.')
          }
        }
      }
    })
  }
}

export default uploadFileApi



// WEBPACK FOOTER //
// ./src/api/upload-file.js